export type IAnimateButton = (
  button: IjQueryElmOrHtmlElm,
  message?: string,
  undo?: boolean
) => void;

export function animateButton(button: IjQueryElmOrHtmlElm, message?: string, undo?: boolean) {
  const $button = $(button);
  const { langObj = {} } = window.DexeroCoreApp.options;
  const msg = message || langObj.progressText;
  const doUndo = undo || $button.hasClass('disabled');
  const iconClass = $button.data('original-icon');
  let iconPosition = 'left';
  if (typeof iconClass !== 'undefined' && iconClass.indexOf('icon-position-right') !== -1) {
    iconPosition = 'right';
  }

  if (doUndo) {
    const origClass = $button.data('original-class');
    const origText = $button.data('original-title');

    if (typeof iconClass !== 'undefined') {
      const icon =
        iconPosition === 'right'
          ? `${origText} <span class="${iconClass}" aria-hidden="true"></span>`
          : `<span class="${iconClass}" aria-hidden="true"></span> ${origText}`;

      $button
        .empty()
        .removeClass()
        .addClass(origClass)
        .append(icon);
    } else {
      $button
        .empty()
        .removeClass()
        .addClass(origClass)
        .append(origText);
    }
  } else {
    const loadingMessage =
      iconPosition === 'left'
        ? `<span class="fa fa-refresh fa-spin" aria-hidden="true"></span> ${msg}`
        : `${msg} <span class="fa fa-refresh fa-spin" aria-hidden="true"></span>`;
    $button
      .empty()
      .append(loadingMessage)
      .addClass('disabled');
  }
}
